import { Avatar, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from "react";
import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../store/user/user.selector';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1.5, 2),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
        borderRadius: 14,
        background: 'linear-gradient(90deg, rgba(238,54,56,0.18) 0%, rgba(26,49,113,0.35) 100%)',
        border: '1px solid rgba(238,54,56,0.25)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    },
    left: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    avatar: {
        width: 42,
        height: 42,
        background: 'linear-gradient(135deg, #ee3638 0%, #c0111a 100%)',
        boxShadow: '0 3px 10px rgba(238,54,56,0.45)',
        '& svg': {
            fontSize: 22,
            color: '#fff',
        },
    },
    heading: {
        fontWeight: 700,
        fontSize: '1rem',
        color: '#ffffff',
        lineHeight: 1.2,
        letterSpacing: 0.3,
    },
    subtext: {
        fontSize: '0.72rem',
        color: 'rgba(255,255,255,0.45)',
        marginTop: 2,
    },
    accent: {
        color: '#ee3638',
        fontWeight: 600,
    },
    actionWrap: {
        flexShrink: 0,
    },
}));

export default function TitleBar(props) {
    const classes = useStyles();
    const { currentUser } = useSelector((state) => {
        return {
            currentUser: getCurrentUser(state) || {},
        }
    });

    return (
        <Box className={classes.root}>
            <Box className={classes.left}>
                <Avatar className={classes.avatar}>
                    {props.icon}
                </Avatar>
                <Box>
                    <Typography className={classes.heading}>{props.heading}</Typography>
                    <Typography className={classes.subtext}>
                        {currentUser.firstName} {currentUser.lastName}
                        {currentUser.memberId && (
                            <> &mdash; <span className={classes.accent}>{currentUser.memberId}</span></>
                        )}
                    </Typography>
                </Box>
            </Box>
            {props.action && <Box className={classes.actionWrap}>{props.action}</Box>}
        </Box>
    );
}